// src/admin/pages/AdminUsers.js
import React from 'react';
import useAdminUsers from '../../components/hooks/hooks-admin/useAdminUsers';
import './admin-users.scss';

function AdminUsers() {
    const {
        loading,
        error,
        filters,
        stats,
        filteredUsers,
        setFilters,
        fetchUsers,
        resetFilters
    } = useAdminUsers();

    if (loading) {
        return (
            <div className="admin-loading">
                <div className="loader"></div>
                <span>Caricamento utenti...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="admin-error">
                <div className="error-icon">⚠️</div>
                <h3>Errore nel caricamento</h3>
                <p>{error}</p>
                <button onClick={fetchUsers} className="retry-btn">
                    🔄 Riprova
                </button>
            </div>
        );
    }

    return (
        <div className="admin-users">
            <div className="users-header">
                <div className="header-title">
                    <h2>👥 Gestione Utenti</h2>
                    <p>Visualizza e gestisci tutti gli utenti registrati</p>
                    <div className="stats">
                        <span className="stat">📊 Totale: {stats.total}</span>
                        <span className="stat">✅ Attivi: {stats.active}</span>
                        <span className="stat">👑 Admin: {stats.admin}</span>
                        <span className="stat">📧 Verificati: {stats.verified}</span>
                        <span className="stat">⏳ In attesa di verifica: {stats.pending}</span>
                    </div>
                </div>
                <div className="users-filters">
                    <div className="search-wrapper">
                        <span className="search-icon">🔍</span>
                        <input
                            type="text"
                            placeholder="Cerca per email, nome o cognome..."
                            value={filters.search}
                            onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
                            className="search-input"
                        />
                    </div>
                    <select
                        value={filters.role}
                        onChange={(e) => setFilters(prev => ({ ...prev, role: e.target.value }))}
                        className="role-filter"
                    >
                        <option value="">🎭 Tutti i ruoli</option>
                        <option value="utente">👤 Utente</option>
                        <option value="admin">👑 Amministratore</option>
                    </select>
                    <button onClick={fetchUsers} className="refresh-btn" disabled={loading}>
                        🔄 Aggiorna
                    </button>
                    {(filters.search || filters.role) && (
                        <button onClick={resetFilters} className="clear-filters-btn">
                            🗑️ Cancella filtri
                        </button>
                    )}
                </div>
            </div>

            <div className="users-table-container">
                <table className="users-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Avatar</th>
                            <th>Utente</th>
                            <th>Email</th>
                            <th>Telefono</th>
                            <th>Data Nascita</th>
                            <th>Registrazione</th>
                            <th>Verifica Email</th>
                            <th>Newsletter</th>
                            <th>Ruolo</th>
                            <th>Stato</th>
                            <th>Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map(user => (
                            <tr key={user.id}>
                                <td>{user.id}</td>
                                <td className="avatar-cell">
                                    <div className="user-avatar">
                                        {user.avatar_url ? (
                                            <img 
                                                src={`/api${user.avatar_url}`}
                                                alt={`Avatar di ${user.nome_utente}`}
                                                className="user-avatar-img"
                                            />
                                        ) : (
                                            <div className="user-avatar-placeholder">
                                                👤
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td>{user.nome_utente} {user.cognome_utente}</td>
                                <td>{user.email_utente}</td>
                                <td className="phone-cell">{user.telefono_utente || '—'}</td>
                                <td>{user.data_nascita ? new Date(user.data_nascita).toLocaleDateString() : '—'}</td>
                                <td>{new Date(user.data_creazione).toLocaleDateString()}</td>
                                <td>
                                    <span className={`verification-badge ${user.email_verificata ? 'verified' : 'pending'}`}>
                                        {user.email_verificata ? '✅ Verificata' : '📧 in attesa'}
                                    </span>
                                </td>
                                <td>
                                    <span className={`newsletter-badge ${user.iscrizione_newsletter ? 'subscribed' : 'unsubscribed'}`}>
                                        {user.iscrizione_newsletter ? '✅ Iscritto' : '❌ Non iscritto'}
                                    </span>
                                </td>
                                <td>
                                    <span className={`role-badge ${user.status_utente === 'admin' ? 'admin' : 'user'}`}>
                                        {user.status_utente}
                                    </span>
                                </td>
                                <td>
                                    <span className={`status-badge ${user.is_attivo ? 'active' : 'inactive'}`}>
                                        {user.is_attivo ? 'Attivo' : 'Disabilitato'}
                                    </span>
                                </td>
                                <td className="actions-cell">
                                    {/* I tuoi pulsanti azioni */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {filteredUsers.length === 0 && (
                <div className="no-results">
                    <div className="no-results-icon">👥</div>
                    <p>Nessun utente trovato</p>
                </div>
            )}
        </div>
    );
}

export default AdminUsers;
